// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".en{color:red}.print-table tr{border-bottom:1px solid #c5cbd3}.print-table tr:last-child{border-bottom:none}", ""]);
// Exports
module.exports = exports;
